module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABJSURBVHgB3ZHBCQAgDAOLEzhC91/CERzBUWI/fkQaRAVpIJ+DaykViRsA2aqMeXK1Fo8xuY1tK/aPnORmjk54NWT/jZOgjAVIB/d3zTPyZhiLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/training2/class/img/chevron-left.double1.png
// module id = HaHe
// module chunks = 96